import { render, staticRenderFns } from "./scrollTable.vue?vue&type=template&id=1f4380c4&scoped=true"
import script from "./scrollTable.vue?vue&type=script&lang=js"
export * from "./scrollTable.vue?vue&type=script&lang=js"
import style0 from "./scrollTable.vue?vue&type=style&index=0&id=1f4380c4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4380c4",
  null
  
)

export default component.exports